import { Suspense } from "react";

import { useDialog } from "~/src/modules/ui-kit";

import LayerDetail from "./LayerDetail";
import LayerCard from "../../entities/layer/LayerCard";


export default function Layer(props) {
    const { onChange, onRemove, ...layerProps } = props;

    const [Dialog, open, close] = useDialog();

    return (
        <Suspense>
            <LayerCard
                { ...layerProps }
                onEdit={ open }
                onRemove={ onRemove }
            />
            <Dialog>
                <LayerDetail
                    { ...layerProps }
                    onChange={ onChange }
                    onClose={ close }
                />
            </Dialog>
        </Suspense>
    );
}
